import { TYRE_LAYOUT_SUBJECT_KINDS, type TyreLayoutSubjectKind } from '@chukua/common';
import { Navigate, useParams, type RouteObject } from 'react-router';
import { VehicleClassPage } from './pages/VehicleClassPage';
import { vehicleClassPath, vehicleClassRoutePattern } from './tyre-layouts.paths';

/** The layout's own page moved onto the row's page; an old link still lands there. */
function RedirectToVehicleClass({ kind }: { kind: TyreLayoutSubjectKind }) {
  const { code = '' } = useParams();
  return <Navigate to={vehicleClassPath(kind, code)} replace />;
}

export const TYRE_LAYOUT_ROUTES: RouteObject[] = TYRE_LAYOUT_SUBJECT_KINDS.flatMap((kind) => [
  { path: vehicleClassRoutePattern(kind), element: <VehicleClassPage subjectKind={kind} /> },
  { path: vehicleClassRoutePattern(kind, '/tyre-layout'), element: <RedirectToVehicleClass kind={kind} /> },
]);
